/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { selectItemToHighlight, setItemToHighlight } from "../../../Retrofit/store/slices/retrofit";

const AxisFiltersRecapLine = ({ axisId, type, data, setEditAxisPopupOpened }) => {
  const itemToHighlight = useSelector(selectItemToHighlight);
  const dispatch = useDispatch();
  return (
    <div
      className={`grid grid-cols-4 rounded-full
    ${type === "input" && itemToHighlight === `all-${axisId}` ? "bg-white drop-shadow shadow-secondary" : ""}`}
      onClick={(e) => {
        if (type === "input") {
          e.stopPropagation();
          setEditAxisPopupOpened(true);
        }
      }}
      onMouseEnter={() => {
        if (type === "input") {
          dispatch(setItemToHighlight(`all-${axisId}`));
        }
      }}
      onMouseLeave={() => {
        dispatch(setItemToHighlight(null));
      }}
    >
      {data.map((item, index) => (
        <>
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={`flex w-full m-auto flex-col text-xs print:text-xxs text-gray-600 ${
              item.highlight ? "border-x hover:border-x border-dashed border-gray-400" : ""
            }
          `}
          >
            <span className="m-auto w-max">
              <div data-tip data-for={`${item.filterName}-filter-${axisId}-${type}`}>
                <span className={`${type === "result" ? "font-bold" : ""}`}>
                  {item.value ? Number(parseFloat(item.value).toFixed(2)) : "-"}
                </span>
                <span className=" font-light"> {item.unit}</span>
              </div>
            </span>
            {/* <ReactTooltip
            id={`${item.filterName}-filter-${axisId}-${type}`}
            place="bottom"
            effect="solid"
            backgroundColor="#0087CD"
          >
            <div>
              {`${t(`msizer.ui.select.${type}_value`)} : ${item.value || "-"} ${
                item.unit
              }`}
            </div>
          </ReactTooltip> */}
          </div>
        </>
      ))}
    </div>
  );
};
AxisFiltersRecapLine.propTypes = {
  axisId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  // data is array of objects with properties:
  // filterName, highlight, value, unit
  data: PropTypes.arrayOf(
    PropTypes.shape({
      filterName: PropTypes.string.isRequired,
      highlight: PropTypes.bool.isRequired,
      value: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired
    })
  ).isRequired,
  setEditAxisPopupOpened: PropTypes.func
};

// default props
AxisFiltersRecapLine.defaultProps = {
  setEditAxisPopupOpened: () => {}
};

export default AxisFiltersRecapLine;
